export const OSIS_TO_USFM_BOOK: Record<string, string> = {
  Gen: 'GEN',
  Exod: 'EXO',
  Lev: 'LEV',
  Num: 'NUM',
  Deut: 'DEU',
  Josh: 'JOS',
  Judg: 'JDG',
  Ruth: 'RUT',
  '1Sam': '1SA',
  '2Sam': '2SA',
  '1Kgs': '1KI',
  '2Kgs': '2KI',
  '1Chr': '1CH',
  '2Chr': '2CH',
  Ezra: 'EZR',
  Neh: 'NEH',
  Esth: 'EST',
  Job: 'JOB',
  Ps: 'PSA',
  Prov: 'PRO',
  Eccl: 'ECC',
  Song: 'SNG',
  Isa: 'ISA',
  Jer: 'JER',
  Lam: 'LAM',
  Ezek: 'EZK',
  Dan: 'DAN',
  Hos: 'HOS',
  Joel: 'JOL',
  Amos: 'AMO',
  Obad: 'OBA',
  Jonah: 'JON',
  Mic: 'MIC',
  Nah: 'NAM',
  Hab: 'HAB',
  Zeph: 'ZEP',
  Hag: 'HAG',
  Zech: 'ZEC',
  Mal: 'MAL',
  Matt: 'MAT',
  Mark: 'MRK',
  Luke: 'LUK',
  John: 'JHN',
  Acts: 'ACT',
  Rom: 'ROM',
  '1Cor': '1CO',
  '2Cor': '2CO',
  Gal: 'GAL',
  Eph: 'EPH',
  Phil: 'PHP',
  Col: 'COL',
  '1Thess': '1TH',
  '2Thess': '2TH',
  '1Tim': '1TI',
  '2Tim': '2TI',
  Titus: 'TIT',
  Phlm: 'PHM',
  Heb: 'HEB',
  Jas: 'JAS',
  '1Pet': '1PE',
  '2Pet': '2PE',
  '1John': '1JN',
  '2John': '2JN',
  '3John': '3JN',
  Jude: 'JUD',
  Rev: 'REV',
};

const osisBookToUsfm = (osisBook: string): string => {
  const usfm = OSIS_TO_USFM_BOOK[osisBook] as string | undefined;
  return usfm || '';
};

const USFM_TO_OSIS_BOOK: Record<string, string> = Object.fromEntries(
  Object.entries(OSIS_TO_USFM_BOOK).map(([osis, usfm]) => [usfm, osis])
);

const osisBookFromUsfm = (usfmBook: string): string => {
  const osis = USFM_TO_OSIS_BOOK[usfmBook] as string | undefined;
  return osis || '';
};

interface OsisPoint {
  book: string;
  chapter: number;
  verse: number;
}

export const parseOsisSegment = (segment: string): OsisPoint => {
  const [book, chapterStr, verseStr] = segment.split('.');

  // TODO: needed?
  // osisBookToUsfm(book)

  const parseComponent = (raw: string | undefined, label: string): number => {
    if (raw === undefined) return 1;

    if (!/^\d+$/.test(raw)) {
      throw new Error(`Invalid ${label} in OSIS segment: ${segment}`);
    }

    const value = Number(raw);
    if (value < 1) {
      throw new Error(`Invalid ${label} in OSIS segment ${segment}`);
    }

    return value;
  };

  return {
    book,
    chapter: parseComponent(chapterStr, 'chapter'),
    verse: parseComponent(verseStr, 'verse'),
  };
};

export const formatUsfmPoint = (point: OsisPoint): string => {
  return `${osisBookToUsfm(point.book)}.${point.chapter}.${point.verse}`;
};

/**
 * Parses a single USFM point (e.g. `PSA.18.21`, as found in API.Bible's
 * `verseId`/`verseOrgIds` fields) into an {@link OsisPoint}, whose `book`
 * is the OSIS book abbreviation.
 *
 * @param segment USFM point to parse
 * @returns The parsed point, with an OSIS book abbreviation
 */
export const parseUsfmSegment = (segment: string): OsisPoint => {
  const [usfmBook, chapterStr, verseStr] = segment.split('.');

  const book = osisBookFromUsfm(usfmBook);
  if (!book) {
    throw new Error(`Unrecognized USFM book in segment: ${segment}`);
  }

  const parseComponent = (raw: string | undefined, label: string): number => {
    if (raw === undefined) return 1;

    if (!/^\d+$/.test(raw)) {
      throw new Error(`Invalid ${label} in USFM segment: ${segment}`);
    }

    const value = Number(raw);
    if (value < 1) {
      throw new Error(`Invalid ${label} in USFM segment: ${segment}`);
    }

    return value;
  };

  return {
    book,
    chapter: parseComponent(chapterStr, 'chapter'),
    verse: parseComponent(verseStr, 'verse'),
  };
};

export const formatOsisPoint = (point: OsisPoint): string => {
  return `${point.book}.${point.chapter}.${point.verse}`;
};
